import { handleLocalStorage } from '../handleLocalStorage'
import i18n from './i18n'
import {
  BUNDLED_LANGUAGES,
  DEFAULT_FALLBACK_ALLOWED_LANGUAGES,
  matchBundledLanguageTag,
  type SupportedLanguage,
} from './i18n'

const bundledSet = new Set<string>(BUNDLED_LANGUAGES)

export function mapApiLanguageToClient(code: string): SupportedLanguage | null {
  if (!bundledSet.has(code)) return null
  return code as SupportedLanguage
}

export function normalizeAllowedLanguagesFromSetup(
  raw: unknown
): SupportedLanguage[] {
  if (!Array.isArray(raw) || raw.length === 0) {
    return [...DEFAULT_FALLBACK_ALLOWED_LANGUAGES]
  }
  const mapped = raw
    .map((item) =>
      typeof item === 'string' ? mapApiLanguageToClient(item) : null
    )
    .filter((x): x is SupportedLanguage => x !== null)
  return mapped.length > 0 ? mapped : [...DEFAULT_FALLBACK_ALLOWED_LANGUAGES]
}

export function normalizeStoredAllowedLanguages(): SupportedLanguage[] {
  const raw = handleLocalStorage('allowedLanguages')
  if (!Array.isArray(raw) || raw.length === 0) {
    return [...DEFAULT_FALLBACK_ALLOWED_LANGUAGES]
  }
  const mapped = raw
    .map((item) =>
      typeof item === 'string' ? mapApiLanguageToClient(item) : null
    )
    .filter((x): x is SupportedLanguage => x !== null)
  return mapped.length > 0 ? mapped : [...DEFAULT_FALLBACK_ALLOWED_LANGUAGES]
}

export function resolveLanguageAfterSetup(
  allowed: SupportedLanguage[],
  selectedLanguageFromRedux: SupportedLanguage
): SupportedLanguage {
  const i18nCode = matchBundledLanguageTag(i18n.language)
  if (i18nCode && allowed.includes(i18nCode)) return i18nCode

  const stored = handleLocalStorage('lang')
  const storedCode =
    typeof stored === 'string' ? matchBundledLanguageTag(stored) : undefined
  if (storedCode && allowed.includes(storedCode)) return storedCode

  if (allowed.includes(selectedLanguageFromRedux))
    return selectedLanguageFromRedux

  return allowed[0]
}
